<template>
  <el-dialog
    class="rc-dialog"
    title="调查人员导入"
    :visible.sync="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item>
        <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
      </el-form-item>

      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="file == null"
      >
        <upload v-model="file" ref="removeFile" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main";
import { importInvestUser } from "@/api/investigation";
import Upload from "@/components/upload/excel";
import { surveyMemberTemplate } from "@/assets/excel/index.js";
import { downloadByUrl } from "../../../utils/common";
export default {
  components: { butn, Upload },
  data() {
    return {
      CUFlag: false,
      investId: "",
      file: null,
      EXCP: surveyMemberTemplate,
    };
  },
  created() {
    vue.$on("importExcel", (item) => {
      this.$nextTick(() => {
        this.CUFlag = true;
        this.investId = item;
      });
    });
  },
  methods: {
    createData() {
      if (this.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("investId", this.investId);
        formData.append("file", this.file);
        importInvestUser(formData).then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data != null) {
              this.$message.error("导入包含错误数据，请检查");
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              this.closeDialog();
            } else {
              this.$message.success(res.msg);
              vue.$emit("tableInit");
              this.closeDialog();
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.file = null;
          }
        });
      }
    },
    closeDialog() {
      this.CUFlag = false;
      // 数据重置
      this.file = null;
    },
    downloadTemplate() {
      downloadByUrl(null, this.EXCP);
    }
  },
  beforeDestroy() {
    vue.$off("importExcel");
  },
};
</script>
